import * as React from 'react';
import { Input as TextInput } from '../../../components/ui';
import { InputWrapper } from "./input.component.style";
import { useState, useId, useEffect, useRef } from "react";

interface InputProps extends React.HTMLProps<HTMLInputElement>{
  password?: boolean;
  error?: string;
  'aria-label'?: string; // Allow custom aria-label for additional context
  [key: string]: any;
}
export function InputComponent({password, ...props} : InputProps){
  const [showPassword, setShowPassword] = useState(false);
  const errorId = useId();
  const hasError = !!props.error;
  const containerRef = useRef<HTMLDivElement>(null);

  // Add ID to error message element after render
  useEffect(() => {
    if (hasError && containerRef.current) {
      const errorElement = containerRef.current.querySelector('.helper-text[data-error]');
      if (errorElement) {
        errorElement.id = errorId;
      }
    }
  }, [hasError, errorId, props.error]);

  // Prepare ARIA attributes for inputs with errors
  const ariaAttributes = hasError ? {
    'aria-describedby': errorId,
    'aria-invalid': true as const
  } : {};

  if(password){
    return (
      <InputWrapper ref={containerRef}>
        <TextInput
          {...props}
          {...ariaAttributes}
          type={showPassword ? 'text' : 'password'}
          className={props.error ? 'invalid' : ''}
          error={props.error}
          />
          <button
            type="button"
            className="input-icon"
            onClick={() => setShowPassword(prev => !prev)}
            aria-label={showPassword ? 'Esconder senha' : 'Mostrar senha'}
            aria-pressed={showPassword}
          >
          {!showPassword ? <i className="fa-regular fa-eye"></i> : <i className="fa-regular fa-eye-slash"></i>}
          </button>
      </InputWrapper>
    )
  }
  return (
    <div ref={containerRef}>
      <TextInput
        {...props}
        {...ariaAttributes}
        className={props.error ? 'invalid' : ''}
        error={props.error}
      />
    </div>
)
}

